import { Agency, agencyBasic } from '@app/models';
import { baseTimetablePeriod, corridor, DictionaryEntity } from '@app/pcs/models';
import { TrainType } from '@app/pcs/models/train-type';
import { TrainId, trainId } from '@dossier/models/train-id';
import { TrainInformation, trainInformation } from '@dossier/models/train-information';
import { gql } from 'apollo-angular';

export interface Dossier {
  id: number;
  version?: number;
  title?: string;
  creatorId?: number;
  route?: string;
  leadingApplicant?: Agency;
  leadingIm?: Agency;
  dossierTypeId?: DictionaryEntity;
  processTypeId?: DictionaryEntity;
  ttp?: any;
  dossierStatusId?: DictionaryEntity;
  internationalTrainNr?: string;
  specialAgreement?: string;
  agencySpecialAgreement?: string;
  trainType?: TrainType;
  catalog?: boolean;
  catalogData?: any;
  trainId?: TrainId;
  flexPap?: boolean;
  fixPap?: boolean;
  trainInformation?: TrainInformation;
}

export const dossier = gql`
  fragment dossier on Dossier {
    id
    version
    title
    creatorId
    leadingApplicant {
      ...agencyBasic
    }
    leadingIm {
      ...agencyBasic
    }
    processTypeId {
      id
      description
    }
    dossierTypeId {
      id
      description
    }
    ttp {
      ...baseTimetablePeriod
    }
    internationalTrainNr
    trainType {
      id
      description
    }
    specialAgreement
    agencySpecialAgreement
    trainId {
      ...trainId
    }
    catalog
    catalogData {
      corridor {
        ...corridor
      }
      papId
      catalogForNewPathRequest
    }
    dossierStatusId {
      id
      description
    }
    flexPap
    fixPap
    trainInformation {
      ...trainInformation
    }
  }
  ${trainId}
  ${trainInformation}
  ${corridor}
  ${agencyBasic}
  ${baseTimetablePeriod}
`;

export enum DossierPropertyMap {
  Title = 'title',
  TrainType = 'trainTypeId',
  Ttp = 'ttpId',
  DossierTypeId = 'dossierTypeId',
  SpecialAgreement = 'agreement',
  ImDetails = 'kmDetail'
}
